import {
  getVivenuContext,
  setVivenuContext
} from "../../chunk-CMDMIKTZ.js";
export {
  getVivenuContext,
  setVivenuContext
};
